export const CUSTOMER_TOKEN = "CUSTOMER_TOKEN";
export const AUTHENTICATED = "AUTHENTICATED";
export const NAME_CUSTOMER = "NAME_CUSTOMER";
export const CUSTOMER_ID = "CUSTOMER_ID";
export const REWARDS = "REWARDS";
